import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Subcontractor from "../app/components/Invoices/Subcontractor";
import Recruiter from "../app/components/Invoices/Recruiter";
import Agency from "../app/components/Invoices/Agency";
import { getFieldData } from "../services/appService";
import { getFilterCandidates, loadCandidatesByFilter } from "../app/store/candidate";

export default function TimeLogManagement(props) {
  const { item, candidateObj, pType } = props;

  const [activeTab, setActiveTab] = useState(0);

  const perfData = candidateObj?.performerData;
  const entType = candidateObj
    ? getFieldData(perfData, "candidateonboardingform", "CandidateEntity")
    : "";

  const showTab0 = entType === "C2C Basis" || pType === "timelog";
  const showTab1 = candidateObj?.recruiter !== null && pType !== "timelog";
  const showTab2 = pType !== "timelog";

  useEffect(() => {
    let dfKey = 0;
    if (showTab0) {
      dfKey = 0;
    } else if (showTab1) {
      dfKey = 1;
    } else if (showTab2) {
      dfKey = 2;
    }
    setActiveTab(dfKey);
  }, [candidateObj, pType, showTab0, showTab1, showTab2]);

  return (
    <>
      <style>{`
        /* Tabs use ReviewTask's .rt-component-actions segmented control, so the
           time log tabs match the Contract Documents / Reporting chips. */
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
          padding-right: 4px !important;
        }
      `}</style>

      <div className="rt-component-actions">
        {showTab0 && (
          <button
            type="button"
            className={`btn btn-sm rt-chip-btn${activeTab === 0 ? " active" : ""}`}
            onClick={() => setActiveTab(0)}
          >
            <i className="fa fa-clock-o mr-1" />
            {entType === "C2C Basis" && pType === "invoice"
              ? "Subcontractor"
              : "Time Log Management"}
          </button>
        )}

        {showTab1 && (
          <button
            type="button"
            className={`btn btn-sm rt-chip-btn${activeTab === 1 ? " active" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            <i className="fa fa-user-circle-o mr-1" />
            Recruiter
          </button>
        )}

        {showTab2 && (
          <button
            type="button"
            className={`btn btn-sm rt-chip-btn${activeTab === 2 ? " active" : ""}`}
            onClick={() => setActiveTab(2)}
          >
            <i className="fa fa-building-o mr-1" />
            Agency/Client
          </button>
        )}
      </div>

      {/* Custom Tab Panels */}
      {showTab0 && activeTab === 0 && (
        <div className="wf-tab-panel">
          <Subcontractor candidate={candidateObj} ptype={pType} entType={entType} />
        </div>
      )}

      {showTab1 && activeTab === 1 && (
        <div className="wf-tab-panel">
          <Recruiter candidate={candidateObj} ptype={pType} entType={entType} />
        </div>
      )}

      {showTab2 && activeTab === 2 && (
        <div className="wf-tab-panel">
          <Agency candidate={candidateObj} ptype={pType} entType={entType} />
        </div>
      )}
    </>
  );
}
